export const CONTROLLER_RECONNECT_GRACE_MS = 10_000;

export async function hardRefreshWebsite(options = {}) {
  const href = options.href || window.location.href;
  const fetchImpl = options.fetchImpl || window.fetch.bind(window);
  const reload = options.reload || (() => window.location.reload());

  try {
    await fetchImpl(href, {
      cache: "reload",
      credentials: "same-origin",
      headers: { "Cache-Control": "no-cache" },
    });
  } catch {
    // Reload even when the preflight request fails; it may recover a broken tab.
  } finally {
    reload();
  }
}
